import React, { Component } from 'react';

//json data
import hubData from '../../data/hub.js'
import globalJSON from '../../data/global.json'
import $ from 'jquery';

//components
import Introduction from './Introduction/Introduction'
import Articles from './Articles/Articles'
import SeriesVideos from './SeriesVideos/SeriesVideos'
import Advert from '../App/Advert/Advert'
import SponsoredVideos from './SponsoredVideos/SponsoredVideos'
import { Helmet } from "react-helmet";
import IsNotDomestic from 'helpers/IsNotDomestic';
import Latest from "./Latest/Latest.js";
import ExternalArticles from './ExternalArticles/ExternalArticles';
import InDepth from './InDepth/InDepth';
import Spacer from './Spacer/Spacer';

import Share from './Share/Share'
import SectionHero from './SectionHero/SectionHero';
import FullWidthTitle from './FullWidthTitle/FullWidthTitle';




//style css
import classes from './hub.module.scss';
import { getFileName } from 'helpers/FileCaching';
const introImages = require.context('../../images/components/Introduction', true, /.*\.(gif|png|jpe?g|svg)$/i);
const globalImages = require.context('../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);


class Hub extends Component {
	constructor(props){
		super();
		window.scrollTo(0,0);

		this.pereviousScrollPercentage = 0;

		this.onScroll = this.onScroll.bind(this)
		window.addEventListener('scroll', this.onScroll)

		let progress25Tracked = false;
        let progress50Tracked = false;
        let progress75Tracked = false;
        let progress100Tracked = false;

		this.state = {
			episodeSelection:{
				series:0, episode:hubData.seriesVideos.seriesList[0].episodes.length-1
			}
		}

	}

	onScroll(){

		var s = this.getCurrentPosition()

		this.heightOfPage()

	}

	heightOfPage(){
	
		var $articleElement = $('div');
		var articleHeight =$articleElement.outerHeight(true);
		var viewPort= window.innerHeight;
		var percentage = ((this.getCurrentPosition() + viewPort) - $articleElement.position().top)/articleHeight * 100;
		var minMaxPercentage = Math.min(100, Math.max(this.pereviousScrollPercentage, percentage));

		// to do tracking checks

		if(minMaxPercentage >= 25){
			if(!this.progress25Tracked) {
				window.gtag('event', "viewed hub",{
				'event_category': globalJSON.tracking.ga_category,
	            'event_label': "scroll 25% progress",
	            'value':10
	          	});
					this.progress25Tracked = true;
				
			}
		}

		if(minMaxPercentage >= 50){
			if(!this.progress50Tracked) {
				window.gtag('event', "viewed hub",{
				'event_category': globalJSON.tracking.ga_category,
	            'event_label': "scroll 50% progress",
	            'value':10
	          	});
				this.progress50Tracked = true;
				
			}
		}
		if(minMaxPercentage >= 75){
			if(!this.progress75Tracked) {
				window.gtag('event', "viewed hub",{
				'event_category': globalJSON.tracking.ga_category,
	            'event_label': "scroll 75% progress",
	            'value':10
	          	});
					this.progress75Tracked = true;
				
			}
		}
			if(minMaxPercentage >= 100){
				if(!this.progress100Tracked) {
					 window.gtag('event', "viewed hub",{
					'event_category': globalJSON.tracking.ga_category,
		            'event_label': "scroll 100% progress",
		            'value':10
		          	});
					this.progress100Tracked = true;
					
				}
			}
			
			
			
			


		this.pereviousScrollPercentage= minMaxPercentage;



	}

	onLatestCtaInteraction(interactionData){

        var elmnt = document.getElementById("series_module__video_container");
        var main_menu = document.getElementById("main_menu");

        if(typeof(window.stop) !== "undefined"){
            //window.stop(true)
            window.scrollTo({top:elmnt.offsetTop - main_menu.offsetHeight, behavior:"smooth"});
        }else{
            window.scrollTo(0,(elmnt.offsetTop - main_menu.offsetHeight));
        }
		setTimeout(this.setState({episodeSelection:interactionData}), 2000)
		this.setState({episodeSelection:interactionData})
	}

	getCurrentPosition = () => {
		return Math.abs(( window.scrollY || document.body.scrollTop || document.documentElement.scrollTop));
	}
	
	componentDidUpdate(){

	}

	componentDidMount(){

		var search = this.props.location.search.substring(1);

		if(search !== ""){
			var queryParams = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
			
			if(queryParams.episode){
				setTimeout(function(){
					this.onLatestCtaInteraction(
						{
							series:parseInt(queryParams.series)-1, 
							episode:parseInt(queryParams.episode)-1
						}
					)
				}.bind(this), 1000)
			}
		}
		
	}

	componentWillUnmount(){

		window.removeEventListener("scroll", this.onScroll);
	}

	render() {
		return (
			<div className={classes.hub}>

				<Helmet>
					<title>{ hubData.meta.title }</title>
					<meta name="keywords" content={hubData.meta.keywords}/>					
					<meta name="description" content={hubData.meta.description} />
					<meta property="fb:app_id" content={globalJSON.social.fb_app_id} />
					<meta property="og:url" content={`${globalJSON.live_url}${process.env.PUBLIC_URL}/index.html`} />
					<meta property="og:type" content="article" />
					<meta property="og:title" content={ hubData.meta.title } />
					<meta property="og:description" content={ hubData.meta.description } />
					<meta property="og:image" content={`${globalJSON.live_url}${getFileName(introImages, hubData.introduction[0].image.desktop)}`} />
					<meta name="twitter:card" content="summary_large_image"/>
					<meta name="twitter:site" content="@BBC_Future"/>
					<meta name="twitter:title" content={ hubData.meta.title } />
					<meta name="twitter:description" content={ hubData.meta.description }/>
					<meta name="twitter:image" content={`${globalJSON.live_url}${getFileName(introImages, hubData.meta.twitterImage)}`} />
				</Helmet>
				{/* INTRODUCTION */}
				<Introduction content={hubData.introduction} windowSize={this.props.windowSize}/>
					
				{/* ARTICLES */}
				<Latest content={hubData.latestContent} windowSize={this.props.windowSize} onCtaInteraction={(selectaionData) => this.onLatestCtaInteraction(selectaionData)}/>
				
				<Spacer/>

				<SectionHero content={hubData.seriesVideos} windowSize={this.props.windowSize} anchorName={'series_module'}/>
				
				<SeriesVideos content={hubData.seriesVideos} episodeSelection={this.state.episodeSelection} windowSize={this.props.windowSize}/>
				<IsNotDomestic>
					<Spacer/>
				</IsNotDomestic>
				<div className={classes.hub__content_container}>
					<Advert column={hubData.advert.columns[0]} content={hubData.advert} windowSize={this.props.windowSize}/>	
					<IsNotDomestic>
						<Spacer/>
						<FullWidthTitle content={hubData.fullWidthTitle} />
						<SponsoredVideos content={hubData.sponsoredVideos} globalImages={this.props.globalImages} windowSize={this.props.windowSize}/>
						<Spacer/>
					</IsNotDomestic>
					
				</div>
			
				<SectionHero content={hubData.InDepth} windowSize={this.props.windowSize} anchorName={'InDepth'}/>
				<div style={{background: '#000000'}}>
					<div className={classes.hub__content_container} >
						<InDepth content={hubData.InDepth} windowSize={this.props.windowSize}/>
					</div>
				</div>
				<div className={classes.hub__content_container} >
					<Advert column={hubData.advert.columns[1]} content={hubData.advert} windowSize={this.props.windowSize}/>
				</div>
			
				<SectionHero content={hubData.articles} windowSize={this.props.windowSize} anchorName={'articles'}/>
				<Articles content={hubData.articles} globalImages={this.props.globalImages} windowSize={this.props.windowSize}/>
				<div className={classes.hub__content_container}>
				
					<Share content={hubData.share}  pageMeta={hubData.meta}/>
				</div>
				<ExternalArticles content={globalJSON.external_articles} globalImages={globalImages} windowSize={this.props.windowSize}/>
				
			</div>
		
		);
	}
}

export default Hub;